<template>
  <div class="h-screen dark:bg-background">
    <main class="h-full">
      <!-- Header -->
      <header class="absolute inset-x-0 top-0 z-50">
        <nav
          class="flex items-center justify-between max-w-7xl mx-auto px-2 py-4 sm:px-6"
        >
          <NuxtLink href="/" class="flex items-center">
            <ClientOnly>
              <div class="relative w-32 sm:w-40">
                <img
                  v-if="$colorMode.value === 'dark'"
                  class="object-cover"
                  alt="DownSub"
                  src="/logo-light.png"
                />
                <img
                  v-else
                  class="object-cover"
                  alt="DownSub"
                  src="/logo.png"
                />
              </div>
            </ClientOnly>
          </NuxtLink>
          <div class="flex items-center gap-x-0 sm:gap-x-2">
            <NuxtLink :to="user ? '/dashboard' : '/auth'">
              <Button variant="default" class="rounded-full">
                {{ user ? $t("common.dashboard") : $t("common.signIn") }}
              </Button>
            </NuxtLink>
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </nav>
      </header>
      <slot />
    </main>
    <Toaster richColors />
  </div>
</template>

<script setup lang="ts">
import { Toaster } from "@/components/ui/sonner";
const user = useSupabaseUser();
</script>

<style scoped></style>
